
<div class="col wccard text-center mx-auto">
  <div class="col mx-auto">
    <div class="">
      <img src="../../assets/new-invite.png">
    </div>

    <div class="row mb-2 mt-6">
      <div class="col text-center">
        <span class="f-16 font-weight-500" style="color: #484B59;">Invitation Received!</span>
      </div>
    </div>

    <div class="row mb-6">
      <div class="col text-center">
        <p class="f-14 font-weight-400" style="color: #484B59;">Confirming this invitation to <b>{{admin_name |
          titlecase}}'s </b> Workspace means you will forfeit access to your current
          workspace and all its contents. Your available credits <b>{{userdata?.balancebasiccontactenrichmentcredits ? userdata?.balancebasiccontactenrichmentcredits : '0'}}</b> will be transferred to the Team Credit Pool of the
          new workspace. Are you certain?
        <p>
      </div>
    </div>

      <div class="mb-3">
         <button data-testid="auto-app-teaminvite-button-1" class="btn-trms-white" [ngClass]="{ 'text-center': showInviteSpinner }" (click)="remindLaterInvitation('remindlater')"
          [disabled]="showInviteSpinner" *ngIf="!invitedWithLink">
          <span [ngClass]="{ 'spinner-border text-blue spinner-size': showInviteSpinner }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showInviteSpinner }">
            {{showInviteSpinner ? '' : 'Remind Later'}}
          </span>
        </button>
        <button data-testid="auto-app-teaminvite-button-2" class="btn-trms-white ml-1" *ngIf="invitedWithLink" (click)="skipInvite()">Skip</button>
        <button data-testid="auto-app-teaminvite-button-3" class="btn-trms-small ml-1" (click)="openConfirmInvitationModel()">Accept</button>
      </div>
  </div>

</div>


<!-- For Accept Invitation model -->  
<ng-template #acceptInvitationModel class="modal">

  <div class="modal-content p-3">

    <div class="d-flex justify-content-between align-items-center">
      <p class="f-14 font-weight-600">Confirm Invitation</p>
      <p class="pointer f-12" (click)="acceptInvitationModelRef.dismiss()"><i class="fa-solid fa-xmark"></i></p>
    </div>
    <p class="f-14 font-weight-400">Confirming this invitation to <b>{{admin_name | titlecase}}'s </b> Workspace means you will forfeit access to your current workspace and all its contents. Are you certain?</p>

     <div class="row">
      <div class="col text-right">
        <button data-testid="auto-app-teaminvite-button-4" class="btn-trms-small" [ngClass]="{ 'text-center': showInviteSpinner }" (click)="acceptApplication('accepted')"
          [disabled]="showInviteSpinner">
          <span [ngClass]="{ 'spinner-border text-white spinner-size': showInviteSpinner }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showInviteSpinner }">
            {{showInviteSpinner ? '' : 'Confirm'}}
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>


<!-- For Remind Later Invitation model -->
<ng-template #remindLaterInvitationModel class="modal">
  <div class="modal-content p-3">
    <div class="d-flex justify-content-between align-items-center">
      <p class="f-14 font-weight-600">Remind Later Invitation</p>
      <p class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></p>
    </div>
    <p class="f-14 font-weight-400">Do you want to Remind Later invitation</p>
     <div class="row">
      <div class="col text-right">
         <button data-testid="auto-app-teaminvite-button-5" class="btn-trms-small" [ngClass]="{ 'text-center': showInviteSpinner }" (click)="remindLaterInvitation('remindlater')"
          [disabled]="showInviteSpinner">
          <span [ngClass]="{ 'spinner-border text-white spinner-size': showInviteSpinner }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showInviteSpinner }">
            {{showInviteSpinner ? '' : 'Confirm'}}
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>




<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ngb-alert class="ngb-alert" style="background-color: yellow !important;" *ngIf="infoMessage" type="info" (close)="infoMessage = ''">
  <span class="infoCheck"><i class="fal fa-info-circle"></i></span>
  <span class="infomsg ml-1">{{ infoMessage }}</span>
</ngb-alert>